
import Vue from 'vue';
import Component from 'vue-class-component';
import { EventBus } from '../connector/EventBus';
import AppConstants from '../model/AppConstants';

@Component
export default class SizeGettersBase extends Vue {
  sizeGetterBackdoor = false;

  mounted() {
    EventBus.$on(AppConstants.BACKDOOR_EVENT_NAME, this.onBackdoor);
    this.sizeGetterBackdoor = !this.sizeGetterBackdoor;
  }

  beforeDestroy() {
    EventBus.$off(AppConstants.BACKDOOR_EVENT_NAME, this.onBackdoor);
  }

  get height() {
    // eslint-disable-next-line no-unused-expressions
    this.sizeGetterBackdoor;
    if (this.$refs['size-getter'] instanceof HTMLElement)
      return this.$refs['size-getter'].offsetHeight;
    return 0;
  }

  get width() {
    // eslint-disable-next-line no-unused-expressions
    this.sizeGetterBackdoor;
    if (this.$refs['size-getter'] instanceof HTMLElement)
      return this.$refs['size-getter'].offsetWidth;
    return 0;
  }

  onBackdoor() {
    this.sizeGetterBackdoor = !this.sizeGetterBackdoor;
  }
}
